// NOTICE: KAPTION-INTEGRATION - home-dashboard-app.WEB.1
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/home-screen'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_kaption_home_screen',
          component: () => import('./Index.vue'),
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
